// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Hero from 'components/Hero';
import SearchMenu from 'components/SearchMenu';
import ScrollWatcherContainer from 'containers/ScrollWatcherContainer';
import HideContainer from 'containers/HideContainer';
import { H1, RichText } from 'components/Text';
import type { ImageData } from 'api/shared';
import {
  transition,
  maxWidth,
  colors,
  gutterWidth,
  fontSizesByType,
  breakpoints,
  shadows
} from '../theme';

const Title = styled.div`
  font-size: ${fontSizesByType.h3[0]}px;
  @media (min-width: ${breakpoints[1]}) {
    font-size: ${fontSizesByType.h3[2]}px;
  }
`;

const FixedMenu = styled.div.attrs(({ isFullyAboveViewport }) => ({
  style: {
    transform: isFullyAboveViewport
      ? 'translateY(0)'
      : 'translateY(-100%) translateY(-4px)'
  }
}))`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  box-shadow: ${shadows.toolbar};
  transition: all ${transition};
  will-change: transform;
`;

const SearchHero = ({
  title,
  image,
  imageMobile,
  onSearch,
  searchMode,
  navSection,
  defaultSearchType,
  showListingCounts,
  parallax,
  pageUrl
}: {|
  title?: string,
  image: ?ImageData,
  imageMobile: ?ImageData,
  onSearch: Function,
  searchMode?: boolean,
  navSection: 'MAIN' | 'STAFF',
  defaultSearchType?: ListingType,
  showListingCounts?: boolean,
  parallax?: boolean,
  pageUrl: string
|}) => (
  <>
    <Hero
      pb={[48, null, null, 64]}
      pt={[48, null, null, 80]}
      mb={[120, null, null, 0]}
      minHeight="calc(100vh - 300px)"
      heroImage={image}
      mobileHeroImage={imageMobile}
      data-qa-id="search-hero"
      parallax={parallax}
      alwaysShow
    >
      {!searchMode && (
        <>
          <Box
            transform={[
              'translateY(180px) translateZ(0)',
              null,
              null,
              'translateZ(0)'
            ]}
            width="100%"
            maxWidth={[400, null, null, maxWidth[3]]}
            px={[0, null, null, gutterWidth]}
            m="0 auto"
          >
            <Box
              width={[1, null, null, 1 / 2]}
              px={[20, null, null, 60]}
              py={[20, null, null, 40]}
              borderRadius={12}
              boxShadow="0 0 6px rgba(0,0,0,0.3)"
              bg="white"
              color={colors.greyishBrown}
            >
              <RichText mb={24}>
                <H1>
                  <Title
                    lineHeight={1.3}
                    dangerouslySetInnerHTML={{
                      __html:
                        title && title.replace(/<(\/?)(p|h1)>/g, '<$1span>')
                    }}
                  />
                </H1>
              </RichText>
              <SearchMenu
                searchMode={searchMode}
                navSection={navSection}
                onSearch={onSearch}
                defaultSearchType={defaultSearchType}
                qaId="search-hero-menu"
                pageUrl={pageUrl}
              />
            </Box>
          </Box>
        </>
      )}
      {/* {cta} */}
    </Hero>
    <ScrollWatcherContainer
      offset={[64, 64, 64, 96 + (showListingCounts ? 80 : 0)]}
    >
      {({ isFullyAboveViewport }) => (
        <HideContainer xs sm md>
          <FixedMenu isFullyAboveViewport={isFullyAboveViewport}>
            <SearchMenu
              searchMode={searchMode}
              navSection={navSection}
              onSearch={onSearch}
              defaultSearchType={defaultSearchType}
              inPageHeader
              qaId="search-hero-menu"
            />
          </FixedMenu>
        </HideContainer>
      )}
    </ScrollWatcherContainer>
  </>
);

export default SearchHero;
